var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.43469 0.833252C4.23667 0.833252 0.833496 4.23642 0.833496 8.43445C0.833496 12.6325 4.23667 16.0356 8.43469 16.0356C10.2294 16.0356 11.8789 15.4136 13.1793 14.3734L17.9724 19.1666L19.1668 17.9722L14.3737 13.179C15.4139 11.8786 16.0359 10.2292 16.0359 8.43445C16.0359 4.23642 12.6327 0.833252 8.43469 0.833252ZM8.43469 2.52241C11.6998 2.52241 14.3467 5.16932 14.3467 8.43445C14.3467 11.6996 11.6998 14.3465 8.43469 14.3465C5.16956 14.3465 2.52265 11.6996 2.52265 8.43445C2.52265 5.16932 5.16956 2.52241 8.43469 2.52241Z",
    fill: "white"
  })));
};
export default SvgSearch;